// src/shared/auth/roles.ts
/* eslint‑disable @typescript-eslint/consistent-type-definitions */

/** Literal strings exactly as they appear inside the JWT `roles` claim */
export enum Role {
  /* global */
  SuperAdmin = 'superadmin',

  /* cash‑flow feature */
  CashFlowAdmin  = 'cash_flow.admin',
  CashFlowEditor = 'cash_flow.editor',
  CashFlowViewer = 'cash_flow.viewer',

  /* purchase‑/sales tables */
  PurchaseTableAdmin = 'purchase_sales.table.admin',
}

/** Coarse‑grained *abilities* mapped to the roles that grant them.
 *
 *  ‣ Add more abilities by creating a new key whose value is **the full list of
 *    roles that should have that capability**.
 *  ‣ Keep this single source‑of‑truth DRY so the rest of the codebase can
 *    simply call `useCan('someAbility')`.
 */
export const Ability = {
  /* ── dining‑tables (purchase_sales.table.*) ────────────────────────── */
  openTable : [Role.SuperAdmin, Role.PurchaseTableAdmin],
  editTable : [Role.SuperAdmin, Role.PurchaseTableAdmin],

  /* ── cash‑flow dashboards / screens ────────────────────────────────── */
  seeCashFlow : [
    Role.SuperAdmin,
    Role.CashFlowAdmin,
    Role.CashFlowEditor,
    Role.CashFlowViewer,     // read‑only viewers
  ],
  editCashFlow : [
    Role.SuperAdmin,
    Role.CashFlowAdmin,
    Role.CashFlowEditor,     // viewers excluded
  ],

  /* ── high‑level admin area (top nav, feature flags, …) ─────────────── */
  seeAdminPanel : [
    Role.SuperAdmin,
    Role.PurchaseTableAdmin,
    Role.CashFlowAdmin,      // editors/viewers don’t get the full panel
  ],
} satisfies Record<string, Role[]>;
